import { render } from "./MSBadgePanel.vue?vue&type=template&id=50de924b&scoped=true&ts=true"
import script from "./MSBadgePanel.vue?vue&type=script&lang=ts"
export * from "./MSBadgePanel.vue?vue&type=script&lang=ts"

import "./MSBadgePanel.vue?vue&type=style&index=0&id=50de924b&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50de924b"]])

export default __exports__